import React from 'react';
import { FileX } from 'lucide-react';
import Link from 'next/link';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

export const NoDataView: React.FC<{ btnVal?: string; herf?: string }> = ({ btnVal, herf }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        <FileX className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-2 text-sm font-medium text-gray-900">No data available</h3>
        {btnVal && (
          <div className="mt-6">
            <Link
              href={herf ?? '/instagram-unfollowers-tracker'}
              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-pink-500 hover:bg-pink-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
            >
              {btnVal}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export function DataTracking({ date }: { date?: string }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="pt-6 text-center space-y-6">
          <div className="w-32 h-32 mx-auto">
            <img
              src="/images/dashboard_track_empty_icon.webp"
              alt="empty"
              // fill
              // className="object-contain"
              // width={128}
              // height={128}
            />
          </div>
          <div className="space-y-2">
            <p className="text-lg text-muted-foreground">{t('Data tracking is ongoing...')}.</p>
            <p className="text-sm">
              {t('Your complete activity report will be submitted before')}
              <span className="text-pink-500 font-medium whitespace-nowrap">{date}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
